import { injectable } from "tsyringe";
import { ExtensionConfig, ExtensionContext } from "../common/models/extension-config";
import { Module } from "../common/module";

@injectable()
export class ElementsIntegrationModule extends Module {
    public name: string = 'ElementsIntegrationModule';
    public acceptedLicenseFlags: string[] = [];
    public shouldRun(context: ExtensionContext): boolean { return true; }

    constructor(){
        super([]);
    }

    private _config: ExtensionConfig | undefined;
    get config(): ExtensionConfig {
        return this._config!;
    }

    public async run(): Promise<void> {
        // parse URL into config
        let u = document.currentScript!.getAttribute('src')!;
        // if we have a relative url, we fake an absolute one (we only parse query params)
        if (u.startsWith("/")) {
            u = `https://starschema.com${u}`;
        }
        const url = new URL(u);
        this._config = {
            appUrl: this.parseUrlParam(url, 'appUrl', true)!,
            context: <ExtensionContext>this.parseUrlParam(url, 'context', true)!,
            isStaticPatch: this.parseBoolUrlParam(url, 'isStaticPatch', true)!,
            routingPatched: this.parseBoolUrlParam(url, 'routingPatched', true)!,
            serverId: this.parseUrlParam(url, 'serverId', true)!,
            serverUrl: this.parseUrlParam(url, 'serverUrl', true)!,
            serverVersion: this.parseUrlParam(url, 'serverVersion', true)!,
            licenseFlags: (this.parseUrlParam(url, 'f', true) || '').split(','),
        }

        
        window.elementsIntegration = { 
            config: this._config
        }
        console.log("Elements integration is active. Context: " + this.config.context);
    }

    private parseUrlParam(url: URL, name: string, required: boolean): string | undefined {
        const a = url.searchParams.get(name);
        if (!a && required) {
            throw new Error(`Required URL parameter: ${name} not found`);
        }
        return a || undefined;
    }
    private parseBoolUrlParam(url: URL, name: string, required: boolean): boolean | undefined {
        return this.parseUrlParam(url, name, required)?.toLowerCase() == 'true';
    }
}